import React, { createContext, useState, useContext, ReactNode } from "react";

interface SelectedItemsContextType {
  selectedItems: number[];
  setSelectedItems: React.Dispatch<React.SetStateAction<number[]>>;
}

const SelectedItemsContext = createContext<
  SelectedItemsContextType | undefined
>(undefined);

export const SelectedItemsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  return (
    <SelectedItemsContext.Provider value={{ selectedItems, setSelectedItems }}>
      {children}
    </SelectedItemsContext.Provider>
  );
};

export const useSelectedItems = () => {
  const context = useContext(SelectedItemsContext);
  if (context === undefined) {
    throw new Error(
      "useSelectedItems must be used within a SelectedItemsProvider"
    );
  }
  return context;
};
